export const SERVICE_SMOKE_CHAMBER_PARGE = {
  label: 'Parge Smoke Chamber',
  value: 'SERVICE_SMOKE_CHAMBER_PARGE'
};

export const SERVICE_SPRAY_PARGE = {
  label: 'Spray Parge Smoke Chamber',
  value: 'SERVICE_SPRAY_PARGE'
};
